import { ParsedUrlQuery } from 'querystring';

export function getUpdatedQuery({
    query,
    formValue,
    isNewHomesDevelopersSearch,
    identifier,
    searchSource,
    viewType
}: {
    query: ParsedUrlQuery;
    formValue: {
        beds_max: string | string[];
        beds_min: string | string[];
        duration: string | string[];
        is_retirement_home: string | string[];
        price_frequency: string | string[];
        price_max: string | string[];
        price_min: string | string[];
        property_sub_type: string[];
        property_type: string | string[];
        q: string | string[];
        radius: string | string[];
        transport_type: string | string[];
    };
    isNewHomesDevelopersSearch: boolean;
    identifier: string;
    searchSource: string;
    viewType: string;
}) {
    const updatedQuery = {
        ...query,
        ...formValue,
        'search-path': isNewHomesDevelopersSearch
            ? [identifier]
            : [formValue['property_type'] as string, ...identifier.split('/')],
        search_source: isNewHomesDevelopersSearch ? '' : searchSource,
        view_type: isNewHomesDevelopersSearch ? '' : viewType
    };

    Object.keys(updatedQuery).forEach((key) => {
        if (updatedQuery[key as keyof typeof updatedQuery] === '') {
            delete updatedQuery[key as keyof typeof updatedQuery];
        }
    });

    if (!isNewHomesDevelopersSearch) {
        if (
            formValue['is_retirement_home'] === 'true' &&
            formValue['property_type'] === 'property'
        ) {
            delete (updatedQuery as Partial<typeof updatedQuery>)[
                'is_retirement_home'
            ];

            updatedQuery['search-path'] = [
                'retirement',
                ...identifier.split('/')
            ];
        }

        if (
            formValue['property_sub_type'].length === 1 &&
            formValue['property_sub_type'][0] === 'bungalow'
        ) {
            updatedQuery['search-path'] = [
                'bungalows',
                ...identifier.split('/')
            ];
        }

        if (formValue['property_type'] !== 'farms_land') {
            delete (updatedQuery as Partial<typeof updatedQuery>)[
                'property_type'
            ];
        }
    }

    return updatedQuery;
}
